import { useAppContext } from "hooks/useContext";
import type { ActiveMembershipIdsType } from "lib/apollo/types";

export const useMembershipIds = (): ActiveMembershipIdsType => {
  const { membershipIds } = useAppContext();
  return membershipIds;
};
